<template lang="pug">
v-dialog(v-model="dialog" width="450px" scrollable)
  v-card.pa-4(dark)
    p.title Создание вебинара
    v-form(v-model="valid")
      v-text-field(
        v-model="form.name"
        filled
        label="Название"
        :rules="[rules.required]"
      )
      select-schedule-type(
        v-model="form.type"
        filled
        label="Тип"
        :rules="[rules.required]"
      )

      time-picker(
        v-model="form.start_at"
        filled
        label="Время начала"
        :rules="ruleForTime"
      )
      time-picker(
        v-model="form.end_at"
        filled
        label="Время окончания"
        :rules="ruleForTime"
      )
      template()
        p.mb-0 Кто проводит вебинар
        v-radio-group(v-model="userType" row).mt-0
          v-radio(label="Гость" :value="0" @click="form.user_id = null")
          v-radio(label="Пользователь" :value="1" @click="form.user_full_name = ''")
          v-radio(label="Я" :value="2")
        v-text-field(
          v-if="userType === 0"
          v-model="form.user_full_name"
          filled
          label="Имя гостя"
          :rules="[rules.required]"
        )
        select-my-user(
          v-model="form.user_id"
          v-if="userType === 1"
          filled
        )
      v-text-field(
        v-if="isAdmin"
        v-model="form.user_full_name"
        filled
        label="Имя гостя"
        :rules="[rules.required]"
      )
      select-region(
        v-if="!isMunicipality && !isRegion"
        v-model="form.region_id"
        filled
        label="Регион"
        :rules="[rules.required]"
      )
      select-mun(
        v-if="!isMunicipality"
        v-model="form.municipality_id"
        :region="form.region_id || user.region_id"
        filled
        label="Муниципалитет"
      )

    v-btn.mb-2(@click="submit" :loading="loading" color="success" :disabled="!valid") Сохранить
    v-btn(@click="dialog= false" text) Отменить
</template>

<script>
import SelectMyUser from '@/components/inputs/SelectMyUser.vue';
import mixinDateTime from '@/mixins/mixinDateTime';
import { CRUDWebinarSchedule } from '@/services/API/_crud';
import rules from '@/lib/rules';
import TimePicker from '@/components/TimePicker.vue';
import SelectRegion from '@/components/inputs/SelectRegion.vue';
import SelectMun from '@/components/inputs/SelectMun.vue';
import SelectScheduleType from '@/components/inputs/SelectScheduleType.vue';
import { mapGetters } from 'vuex';

const DEFAULT_FORM = {
  name: '',
  type: '',
  start_at: '12:00',
  end_at: '13:00',
  region_id:'',
  municipality_id:'',
  organization_id:'',
  // organization_name:'',
  user_full_name:'',
  user_id: null,
};

export default {
  components:{
    SelectMyUser,
    TimePicker,
    SelectRegion,
    SelectMun,
    SelectScheduleType,
  },
  mixins: [mixinDateTime],
  props:{
    value: { type: Boolean, required: true },
    data: { type:Object, rerequired: false, default: null },
    day: { type: Date, rerequired: true, default: null },
  },
  data() {
    return {
      userType: 0,
      dialog: false,
      valid: false,
      loading: false,
      rules,
      form: { ...DEFAULT_FORM },
    };
  },
  computed: {
    ...mapGetters({
      // Обязательно(!!!!) поискать способ во vuex импортить все геттеры.
      'isMunicipality':'auth/isMunicipality',
      'isSupport': 'auth/isSupport',
      'isAdmin':'auth/isAdmin',
      'isRegion': 'auth/isRegion',
      'user': 'auth/getUser',
    }),
    // LOH возращать массив
    ruleForTime() {
      if (this.form.start_at && this.form.end_at) {
        return this.form.start_at < this.form.end_at || ['Введите корректное время'];
      }
      return true;
    },
  },
  watch:{
    value:{
      immediate: true,
      handler(v) {
        if (v && this.data) {
          this.form  = this.data;
        }
        this.dialog  = v;
      },
    },
    dialog(v) {
      this.$emit('input', v);
    },
  },
  methods:{
    async submit() {
      this.loading = true;
      try {
        const params = { ...this.form };
        const date = new Date(this.day.getFullYear(), this.day.getMonth() - 1, this.day.getDate());
        const start_at = new Date(date);
        const end_at = new Date(date);
        const startTime = params.start_at.split(':');
        const endTime = params.end_at.split(':');
        // start_at.setHours(startTime[0] - (this.user.timezone.title.slice(4, 5) - 1), startTime[1]);
        // end_at.setHours(endTime[0] - (this.user.timezone.title.slice(4, 5) - 1), endTime[1]);
        start_at.setHours(...startTime);
        end_at.setHours(...endTime);

        params.start_at = this.parseDateTime(start_at);
        params.end_at = this.parseDateTime(end_at);

        if (this.userType === 0) {
          delete params.user_id;
        }
        if (this.isRegion || params.municipality_id === null) {
          params.region_id = this.user.region_id;
        }
        if (this.userType === 1) delete params.user_full_name;
        if (!params.municipality_id) delete params.municipality_id;
        if (this.userType === 2) {
          delete params.user_full_name;
          params.user_id = this.user.id;
        }
        const response = await CRUDWebinarSchedule.create(params);
        this.$emit('addNewSchedules', response.data.data);
        this.$toast.success('Запись успешно добавлена');
        this.form = { ...DEFAULT_FORM };
        this.dialog = false;
      } catch (error) {
        this.$toast.error(error.data);
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style>

</style>
